/**
 * @description
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { CommentParentType } from '@umu/umu-types';

export interface IInput {
    parent_type: CommentParentType;
    comment_id: number;
    is_top: 0 | 1;
}

export interface IOutput {
    count: number;
}

export const commentTop = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.COMMENT_TOP, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
};
